<form #form="ngForm">
    <li>
        <a href="javascript: void(0);" name="selectStation" id="selectStation" (click)="selectInmap(station);" >{{station.id}} {{station.name}}</a>
    </li>
</form>